// OurProduct.tsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function OurProduct() {
  const navigate = useNavigate();

  const handleFlozClick = () => {
    navigate("/Floz");
  };

  return (
    <div
      style={{
        width: "90vw",
        maxWidth: "1290px",
        margin: "10vh auto",
        textAlign: "left",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* ---------- Flagship Heading ---------- */}
      <div style={{ marginBottom: "3rem", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "48px",
            fontWeight: "bold",
            color: "#0D1C17",
            marginBottom: "0.75rem",
          }}
        >
          <span style={{ color: "#059669" }}>Flagship Platforms</span> for
          Global Impact
        </h1>

        <p
          style={{
            fontSize: "18px",
            color: "#4B5563",
            maxWidth: "720px",
            margin: "0 auto 1.5rem",
            lineHeight: "1.6",
          }}
        >
          Our suite of innovative platforms leverages cutting-edge technology to
          address critical challenges in water management and agriculture,
          driving sustainable solutions for a better future.
        </p>

        <div
          style={{
            width: "192px",
            height: "4px",
            background: "linear-gradient(to right, #14b8a6, #10b981)",
            margin: "0 auto",
          }}
        />
      </div>

      {/* ---------- Two Clickable Cards ---------- */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        {/* ==== FLOZ - Internal Navigation ==== */}
        <div
          onClick={handleFlozClick}
          style={{
            textDecoration: "none",
            flex: "1",
            minWidth: "280px",
            cursor: "pointer",
          }}
        >
          <div
            style={{
              background: "#F7FCFA",
              borderRadius: "8px",
              padding: "1rem",
              border: "2px solid #CCEBE3",
              boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
              transition: "transform 0.2s, box-shadow 0.2s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "translateY(-4px)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "translateY(0)")
            }
          >
            <div style={{ marginBottom: "1rem" }}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1374_1786)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 3.75C11.8752 3.7524 9.01929 5.51831 7.62094 8.31281C5.39765 7.98856 3.17951 8.93363 1.87326 10.7617C0.567001 12.5898 0.391555 14.9945 1.41864 16.9928C2.44572 18.9911 4.50319 20.2481 6.75 20.25H15C19.5563 20.25 23.25 16.5563 23.25 12C23.25 7.44365 19.5563 3.75 15 3.75ZM15 18.75H6.75C4.26472 18.75 2.25 16.7353 2.25 14.25C2.25 11.7647 4.26472 9.75 6.75 9.75C6.85313 9.75 6.95625 9.75 7.05844 9.76031C6.85333 10.4892 6.74955 11.2428 6.75 12C6.75 12.4142 7.08579 12.75 7.5 12.75C7.91421 12.75 8.25 12.4142 8.25 12C8.25 8.27208 11.2721 5.25 15 5.25C18.7279 5.25 21.75 8.27208 21.75 12C21.75 15.7279 18.7279 18.75 15 18.75Z"
                    fill="#0D1C17"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1374_1786">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>

            <h3
              style={{
                fontWeight: "600",
                color: "#0D1C17",
                margin: "0.8rem 0",
                fontSize: "1.25rem",
              }}
            >
              FLOZ
            </h3>

            <p
              style={{
                color: "#45A187",
                lineHeight: "1.5",
                margin: 0,
              }}
            >
              A climate & hydrology modeling interface integrating advanced
              simulation tools.
            </p>
          </div>
        </div>

        {/* ==== inFarmer - External Link ==== */}
        {/* <a
          href="https://infarmer.io/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", flex: "1", minWidth: "280px" }}
        >
          <div
            style={{
              background: "#F7FCFA",
              borderRadius: "8px",
              padding: "1rem",
              border: "2px solid #CCEBE3",
              boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
              cursor: "pointer",
              transition: "transform 0.2s, box-shadow 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-4px)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
          >
            <div style={{ marginBottom: "1rem" }}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23.2155 3.73901C23.1933 3.35922 22.8903 3.05619 22.5105 3.03401C17.658 2.75276 13.7617 4.22839 12.0873 6.99214C10.9811 8.81932 10.983 11.0384 12.0723 13.1553C11.4523 13.8934 10.9991 14.7569 10.7439 15.6865L9.21859 14.1556C9.95171 12.6246 9.92359 11.029 9.12484 9.70339C7.88734 7.66057 5.03077 6.56557 1.48421 6.7737C1.10442 6.79588 0.801392 7.0989 0.779212 7.4787C0.57015 11.0253 1.66609 13.8818 3.7089 15.1193C4.38302 15.5312 5.15767 15.7492 5.94765 15.7493C6.71443 15.7399 7.46928 15.5582 8.1564 15.2178L10.5001 17.5615V20.2493C10.5001 20.6635 10.8359 20.9993 11.2501 20.9993C11.6644 20.9993 12.0001 20.6635 12.0001 20.2493V17.4846C11.9968 16.2915 12.4028 15.1333 13.1505 14.2034C14.1151 14.7075 15.1849 14.9773 16.2733 14.9909C17.3255 14.9943 18.3582 14.7068 19.2573 14.1603C22.0211 12.4878 23.5005 8.59151 23.2155 3.73901ZM4.48234 13.8368C3.04421 12.9659 2.23046 10.9043 2.25015 8.24932C4.90515 8.22682 6.96671 9.04339 7.83765 10.4815C8.29234 11.2315 8.3664 12.1062 8.06827 13.0071L5.77984 10.7187C5.48496 10.4386 5.02053 10.4445 4.73293 10.7321C4.44532 11.0197 4.43938 11.4841 4.71953 11.779L7.00796 14.0674C6.10702 14.3656 5.23327 14.2915 4.48234 13.8368ZM18.4802 12.8787C17.2239 13.639 15.7473 13.6971 14.2473 13.0662L19.2808 8.03183C19.5609 7.73695 19.555 7.27252 19.2674 6.98492C18.9798 6.69731 18.5153 6.69137 18.2205 6.97151L13.1861 11.9993C12.5523 10.4993 12.6095 9.02182 13.3736 7.76651C14.6805 5.61026 17.7798 4.40839 21.7483 4.5012C21.8383 8.4687 20.6383 11.5718 18.4802 12.8787Z"
                  fill="#0D1C17"
                />
              </svg>
            </div>

            <h3
              style={{
                fontWeight: "600",
                color: "#0D1C17",
                margin: "0.8rem 0",
                fontSize: "1.25rem",
              }}
            >
              inFarmer
            </h3>

            <p
              style={{
                color: "#45A187",
                lineHeight: "1.5",
                margin: 0,
              }}
            >
              A precision agriculture and risk platform powered by satellite monitoring and AI.
            </p>
          </div>
        </a> */}
      </div>
    </div>
  );
}
